<template>
  <div>
    <v-tabs v-model="activeTab" color="realEstate">
      <v-tab
        key="SINGLE_PURCHASE"
        @click="setSubscriptionType('SINGLE_PURCHASE')"
      >
        {{ $t('paymentTypes.SINGLE_PURCHASE') }}
      </v-tab>
      <v-tab
        key="SUBSCRIPTION_TRIMESTER"
        @click="setSubscriptionType('SUBSCRIPTION_TRIMESTER')"
      >
        {{ $t('paymentTypes.SUBSCRIPTION_TRIMESTER') }}
      </v-tab>
      <v-tab
        key="SUBSCRIPTION_SEMESTER"
        @click="setSubscriptionType('SUBSCRIPTION_SEMESTER')"
      >
        {{ $t('paymentTypes.SUBSCRIPTION_SEMESTER') }}
      </v-tab>
      <v-tab
        key="SUBSCRIPTION_YEAR"
        @click="setSubscriptionType('SUBSCRIPTION_YEAR')"
      >
        {{ $t('paymentTypes.SUBSCRIPTION_YEAR') }}
      </v-tab>
      <v-tab
        key="SUBSCRIPTION_LIFELONG"
        @click="setSubscriptionType('SUBSCRIPTION_LIFELONG')"
      >
        {{ $t('paymentTypes.SUBSCRIPTION_LIFELONG') }}
      </v-tab>
      <v-tab
        key="TRIAL"
        @click="setSubscriptionType('TRIAL')"
      >
        {{ $t('paymentTypes.TRIAL') }}
      </v-tab>
      <v-tab
        key="PREPAID"
        @click="setSubscriptionType('PREPAID')"
      >
        {{ $t('paymentTypes.PREPAID') }}
      </v-tab>
      <v-tab
        key="PREPAID_SAAS"
        @click="setSubscriptionType('PREPAID_SAAS')"
      >
        {{ $t('paymentTypes.PREPAID_SAAS') }}
      </v-tab>
      <v-tab
        key="POSTPAID"
        @click="setSubscriptionType('POSTPAID')"
      >
        {{ $t('paymentTypes.POSTPAID') }}
      </v-tab>
      <v-tab
        key="POSTPAID_SAAS"
        @click="setSubscriptionType('POSTPAID_SAAS')"
      >
        {{ $t('paymentTypes.POSTPAID_SAAS') }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'DefaultServiceValuesTabs',

  data() {
    return {
      activeTab: null,
    }
  },

  methods: {
    ...mapActions(['fetchDefaultServiceValues']),
    ...mapMutations(['setFilters', 'setDefaultServiceValues']),

    setSubscriptionType(subscription) {
      this.setDefaultServiceValues([])
      this.setFilters({
        ...this.$store.getters.filters,
        ...{ type: subscription },
      })
      this.fetchDefaultServiceValues()
    },
  },

  mounted() {
    this.setFilters({
      ...this.$store.getters.filters,
      ...{ type: 'SINGLE_PURCHASE' },
    })
    this.fetchDefaultServiceValues()
  },
}
</script>
